/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Scan_LeadInputs */

const en_features_scan_lead = /** @type {(inputs: Features_Scan_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A photo instead of a scale.`)
};

const pl_features_scan_lead = /** @type {(inputs: Features_Scan_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdjęcie zamiast ważenia.`)
};

/**
* | output |
* | --- |
* | "A photo instead of a scale." |
*
* @param {Features_Scan_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_scan_lead = /** @type {((inputs?: Features_Scan_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Scan_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_scan_lead(inputs)
	return en_features_scan_lead(inputs)
});